import { useMutation } from "react-query";
import { deleteAlarm } from "../../../../actions/CarrierAgreementMgmt/Security";

const useDeleteAlarm = () => {
  return useMutation(deleteAlarm);
};
export default useDeleteAlarm;
